// sagas.js
import { takeLatest, put } from 'redux-saga/effects';
import { getAllCategoryReduxSuccess, getAllCategoryReduxError, getServicesSuccess, getServicesError, getCountriesSuccess, getCountriessError, createServicesError, createServicesSuccess, updateServicesError, updateServicesSuccess, changeStatusServicesError, changeStatusServicesSuccess, updateServicesStatusSuccess, updateServicesStatusError, deleteServicesError, deleteServicesSuccess, getCouponsError, getCouponsSuccess, createCouponsError, createCouponsSuccess, updateCouponsStatusError, updateCouponsStatusSuccess, updateCouponsSuccess, updateCouponsError, getPoliciesDataSuccess, getPoliciesDataError, getAllProductsSuccess, getAllProductsError, getCategoryForAllSuccess, getCategoryForAllError } from './action';
import { activateService, creatNewCoupon, creatNewService, editCoupon, editServices, getAllCategory, getAllCoupons, getAllService, activateCoupon, getAllProductList } from '../../api';
import { CHANGE_STATUS_SERVICES, CHANGE_STATUS_SERVICES_TO_ACTIVE, CREATE_COUPONS, CREATE_SERVICES, DELETE_SERVICES, GET_ALL_CATEGORY, GET_ALL_COUNTRIES, GET_ALL_COUPONS, GET_ALL_SERVICES, UPDATE_COUPONS, UPDATE_COUPONS_STATUS, UPDATE_SERVICES, UPDATE_SERVICES_STATUS, GET_ALL_PRODUCTS, GET_POLICIES, CHANGE_STATUS_COUPONS, CHANGE_STATUS_COUPONS_TO_ACTIVE, GET_CATEGORY_FOR_ALL } from '../actionTypes';
import Axios from 'axios';
import SweetAlert from 'sweetalert2';
import { toast } from 'react-toastify';

function* getAllCategorySaga(action) {
  try {
    const { setTotalData, setDataHolder, settotalPage, getCount } = action.payload;
    const data = yield getAllCategory()
    setTotalData(data.data.result)
    setDataHolder(data.data.result)
    settotalPage(Array.from({ length: Math.ceil(data.data.result.length / 6) }, (v, i) => i + 1))
    getCount(1, data.data.result)
    if (data) {
      yield put(getAllCategoryReduxSuccess(data.data.result));
    }
  } catch (error) {
    yield put(getAllCategoryReduxError(error));
  }
}
function* getAllCategoryForAllSaga() {
  try {
    
    const data = yield getAllCategory()
    if (data) {
      yield put(getCategoryForAllSuccess(data.data.result));
    }
  } catch (error) {
    yield put(getCategoryForAllError(error));
  }
}

function* getAllServicesSaga(action) {
  try {
    const { page, rowsPerPage, searchText, columnFilters, sorting, setData, setCount, setIsLoading } = action.payload;
    setIsLoading(true);
    const data = yield getAllService(page, rowsPerPage, searchText, columnFilters, sorting);
    if (data) {
      setData(data.data.result.data);
      setCount(data.data?.result?.totalRows);  
      yield put(getServicesSuccess(data.data.result.data));
      setIsLoading(false);
    }
  } catch (error) {
    yield put(getServicesError(error));
  }
}

function* getCountriesSaga(action) {
  try {
    const data = yield Axios.get(`${process.env.PUBLIC_URL}/api/EPortal2.0/ADMIN/SALES/TAXES/COUNTRIES/AllCountriesData.json`)
    if (data) {
      yield put(getCountriesSuccess(data.data.data.filter((x) => { return x.status === 'ACTIVE' })));
    }
  } catch (error) {
    yield put(getCountriessError(error));
  }
}

// Create Service
function* createServicesSaga(action) {
  const { formData, toggleModal, refresh, setIsSubmitting } = action.payload;
  try {
    setIsSubmitting(true);
    const createServiceRes = yield creatNewService(formData);
    if (createServiceRes.status === 200) {
      // roles.forEach((role) => {
      //   creatNewUserHasRole({ role_id: role.value, user_id: createServiceRes.data.result.user_id })
      //     .then().catch((error) => toast.error(error.response.data.error))
      // })
      SweetAlert.fire({ title: "Services Created Successfully", icon: "success" }).then((result) => {
        setIsSubmitting(false);
        toggleModal();
        refresh();
      });
    }
    if (createServiceRes) {
      // yield put(createUserSuccess(data.data?.result?.users));
      yield put(createServicesSuccess(createServiceRes.data.msg));
      setIsSubmitting(false);
    }
  } catch (error) {
    toast.error(error.response.data.error)
    yield put(createServicesError(error.response.data.error));
  }
}

//Update Services Status
function* updateServicesStatusSaga(action) {
  try {
    const { sales_service_id } = action.payload;
    const updateServiceStatusRes = yield activateService(sales_service_id);
    // status = true
    // flag = true
    // SweetAlert.fire({ title: "Status Updated Successfully", icon: "success" }).then((result) => {
    //   toggleModal();
    //   refresh();
    // });
    if (updateServiceStatusRes) {
      // yield put(createUserSuccess(data.data?.result?.users));
      yield put(updateServicesStatusSuccess('Status changed while updating services'));

    }
  } catch (error) {
    toast.error(error.response.data.error)
    yield put(updateServicesStatusError(error.response.data.error));
  }
}

//Update Services
function* updateServicesSaga(action) {
  const { sales_service_id, ServiceData, toggleModal, refresh, setIsSubmitting } = action.payload;
  try {
    setIsSubmitting(true);
    const updateServiceRes = yield editServices(sales_service_id, ServiceData);
    if (updateServiceRes.status === 200) {
      SweetAlert.fire({ title: "Services Updated Successfully", icon: "success" }).then((result) => {
        setIsSubmitting(false);
        toggleModal();
        refresh();
      });
    }
    if (updateServiceRes) {
      // yield put(createUserSuccess(data.data?.result?.users));
      yield put(updateServicesSuccess(updateServiceRes.data.msg));
    }
  } catch (error) {
    toast.error(error.response.data.error)
    setIsSubmitting(false);
    yield put(updateServicesError(error.response.data.error));
  }
}

// Delete Service
function* deleteServicesSaga(action) {
  try {
    const { sales_service_id, statusData, refresh } = action.payload;
    const deleteServiceRes = yield activateService(sales_service_id, statusData);
    if (deleteServiceRes.status === 200) {
      SweetAlert.fire({ title: "Service deleted Successfully.", icon: "success" }).then((result) => {        
        refresh();
      });
    }
    if (deleteServiceRes) {
      yield put(deleteServicesSuccess('Service Deleted'));
    }
  } catch (error) {
    // toast.error(error.response.data.error)
    yield put(deleteServicesError(error)); 
  }
}

// Changes Service Status - Active to Inactive
function* changeStatusServicesSaga(action) {
  try {
    const { sales_service_id, payload_param, refresh } = action.payload;
    const changeStatusServiceRes = yield editServices(sales_service_id, payload_param);
    if (changeStatusServiceRes.status === 200) {
      SweetAlert.fire({ title: "Status Updated Successfully", icon: "success" }).then((result) => {
        refresh();
      });
    }
    if (changeStatusServiceRes) {
      // yield put(createUserSuccess(data.data?.result?.users));
      yield put(changeStatusServicesSuccess(changeStatusServiceRes.data.msg));
    }
  } catch (error) {
    toast.error(error.response.data.error)
    yield put(changeStatusServicesError(error.response.data.error));
  }
}

// Changes Service Status - Inactive to Active 
function* changeStatusServicesToActiveSaga(action) {
  try {
    const { sales_service_id, refresh } = action.payload;
    const changeStatusServiceRes = yield activateService(sales_service_id);
    if (changeStatusServiceRes.status === 200) {
      SweetAlert.fire({ title: "Status Updated Successfully", icon: "success" }).then((result) => {
        refresh();
      });
    }
    if (changeStatusServiceRes) {
      // yield put(createUserSuccess(data.data?.result?.users));
      yield put(changeStatusServicesSuccess(changeStatusServiceRes.data.msg));
    }
  } catch (error) {
    toast.error(error.response.data.error)
    yield put(changeStatusServicesError(error.response.data.error));
  }
}


// Get all products
function* getAllProductsSaga(action) {
  try {
    const { page, rowsPerPage, searchText, filterList, sorting, setData, setCount, setIsLoading } = action.payload;
    setIsLoading(true);
    const data = yield getAllProductList(page, rowsPerPage, searchText || '', filterList, sorting);
    if (data) {
      yield put(getAllProductsSuccess(data.data?.result?.products));
      setData(data.data?.result?.products);
      setCount(data.data?.result?.totalRows);
      setIsLoading(false);

    }
  } catch (error) {
    yield put(getAllProductsError(error));
  }
}

function* getPoliciesSaga(action) {
  try {
    const data = yield Axios.get(`${process.env.PUBLIC_URL}/api/EPortal2.0/ADMIN/SALES/POLICIES/AllPoliciesData.json`)
      if (data) {
        yield put(getPoliciesDataSuccess(data.data.data));
        }
  } catch (error) {
    yield put(getPoliciesDataError(error.response.data.error)); 
  }
}

// Coupons
function* getAllCouponsSaga(action) {
  try {
    const { page, rowsPerPage, searchText, columnFilters, sorting, setCount, setData, setIsLoading } = action.payload;
    setIsLoading(true);
    const data = yield getAllCoupons(page, rowsPerPage, searchText, columnFilters, sorting);
    if (data) {
      setData(data.data.result.data);
      setCount(data.data?.result?.totalRows);
      yield put(getCouponsSuccess(data.data.result.data));
      setIsLoading(false);
    }
  } catch (error) {
    yield put(getCouponsError(error));
  }
}

function* createCouponsSaga(action) {
  const { formData, toggleModal, refresh, setIsSubmitting } = action.payload;
  try {
    setIsSubmitting(true);
    const createCouponRes = yield creatNewCoupon(formData);
    if (createCouponRes.status === 200) {
      SweetAlert.fire({ title: "Coupon Created Successfully", icon: "success" }).then((result) => {
        setIsSubmitting(false);
        toggleModal();
        refresh();
      });
    }
    if (createCouponRes) {
      // yield put(createUserSuccess(data.data?.result?.users));
      yield put(createCouponsSuccess(createCouponRes.data.msg));

    }
  } catch (error) {
    toast.error(error.response.data.error)
    yield put(createCouponsError(error.response.data.error));
    setIsSubmitting(false);

  }
}

//Update Coupons Status
function* updateCouponsStatusSaga(action) {
  try {
    const { sales_coupon_id } = action.payload;
    const updateCouponsStatusRes = yield activateService(sales_coupon_id);
    if (updateCouponsStatusRes) {
      // yield put(createUserSuccess(data.data?.result?.users));
      yield put(updateCouponsStatusSuccess(updateCouponsStatusRes.data.msg));
    }
  } catch (error) {
    toast.error(error.response.data.error)
    yield put(updateCouponsStatusError(error.response.data.error));
  }
}

function* updateCouponsSaga(action) {
  const { sales_coupon_id, CouponData, toggleModal, refresh, setIsSubmitting } = action.payload;
  try {
    setIsSubmitting(true);
    const updateCouponsRes = yield editCoupon(sales_coupon_id, CouponData);
    if (updateCouponsRes.status === 200) {
      SweetAlert.fire({ title: "Coupon Updated Successfully", icon: "success" }).then((result) => {
        setIsSubmitting(false);
        toggleModal();
        refresh();
      });
    }
    if (updateCouponsRes) {
      // yield put(createUserSuccess(data.data?.result?.users));
      yield put(updateCouponsSuccess(updateCouponsRes.data.msg));

    }
  } catch (error) {
    toast.error(error.response.data.error)
    setIsSubmitting(false);
    yield put(updateCouponsError(error.response.data.error));
  }
}

// Changes Coupon Status - Active to Inactive
function* changeStatusCouponsSaga(action) {
  try {
    const { sales_coupon_id, payload_param, refresh } = action.payload;
    const changeStatusCouponRes = yield editCoupon(sales_coupon_id, payload_param);
    if (changeStatusCouponRes.status === 200) {
      SweetAlert.fire({ title: "Status Updated Successfully", icon: "success" }).then((result) => {
        refresh();
      });
    }
    if (changeStatusCouponRes) {
      // yield put(createUserSuccess(data.data?.result?.users));
      yield put(changeStatusServicesSuccess(changeStatusCouponRes.data.msg));

    }
  } catch (error) {
    toast.error(error.response.data.error)
    yield put(changeStatusServicesError(error.response.data.error));
  }
}

// Changes Coupon Status - Inactive to Active 
function* changeStatusCouponsToActiveSaga(action) {
  try {
    const { sales_coupon_id, refresh } = action.payload;
    const changeStatusCouponRes = yield activateCoupon(sales_coupon_id);
    if (changeStatusCouponRes.status === 200) {
      SweetAlert.fire({ title: "Status Updated Successfully", icon: "success" }).then((result) => {
        refresh();
      });
    }
    if (changeStatusCouponRes) {
      // yield put(createUserSuccess(data.data?.result?.users));
      yield put(changeStatusServicesSuccess(changeStatusCouponRes.data.msg));

    }
  } catch (error) {
    toast.error(error.response.data.error)
    yield put(changeStatusServicesError(error.response.data.error));
  }
}


export function* watchSalesData() {
  yield takeLatest(GET_ALL_CATEGORY, getAllCategorySaga);
  yield takeLatest(GET_ALL_COUNTRIES, getCountriesSaga);
  // Services
  yield takeLatest(GET_ALL_SERVICES, getAllServicesSaga);
  yield takeLatest(CREATE_SERVICES, createServicesSaga);
  yield takeLatest(UPDATE_SERVICES_STATUS, updateServicesStatusSaga);
  yield takeLatest(UPDATE_SERVICES, updateServicesSaga);
  yield takeLatest(DELETE_SERVICES, deleteServicesSaga);
  yield takeLatest(CHANGE_STATUS_SERVICES, changeStatusServicesSaga);
  yield takeLatest(CHANGE_STATUS_SERVICES_TO_ACTIVE, changeStatusServicesToActiveSaga);
  yield takeLatest(GET_ALL_PRODUCTS, getAllProductsSaga);
  yield takeLatest(GET_POLICIES, getPoliciesSaga);
  // Coupons
  yield takeLatest(GET_ALL_COUPONS, getAllCouponsSaga);
  yield takeLatest(CREATE_COUPONS, createCouponsSaga);
  yield takeLatest(UPDATE_COUPONS_STATUS, updateCouponsStatusSaga);
  yield takeLatest(UPDATE_COUPONS, updateCouponsSaga);
  yield takeLatest(CHANGE_STATUS_COUPONS, changeStatusCouponsSaga);
  yield takeLatest(CHANGE_STATUS_COUPONS_TO_ACTIVE, changeStatusCouponsToActiveSaga);

  yield takeLatest(GET_CATEGORY_FOR_ALL, getAllCategoryForAllSaga);
}

